"use strict";
exports.__esModule = true;
exports.DOCUMENT_TYPE = exports.SUB_CLIENT_REMINDER_TYPE = exports.PMS_POS = exports.CUSTOM_ENUM = exports.STATE_TAX_RECEIPT_TYPE = exports.BOT_TYPE = exports.BOT_MACHINE_LOG_STATUS = exports.PDF_TYPE = exports.SUB_CLIENT_EXTRACTION_STATUS = void 0;
var SUB_CLIENT_EXTRACTION_STATUS;
(function (SUB_CLIENT_EXTRACTION_STATUS) {
    SUB_CLIENT_EXTRACTION_STATUS["PENDING"] = "PENDING";
    SUB_CLIENT_EXTRACTION_STATUS["RUNNING"] = "RUNNING";
    SUB_CLIENT_EXTRACTION_STATUS["SUCCESS"] = "SUCCESS";
    SUB_CLIENT_EXTRACTION_STATUS["FAILED"] = "FAILED";
    SUB_CLIENT_EXTRACTION_STATUS["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
})(SUB_CLIENT_EXTRACTION_STATUS = exports.SUB_CLIENT_EXTRACTION_STATUS || (exports.SUB_CLIENT_EXTRACTION_STATUS = {}));
var PDF_TYPE;
(function (PDF_TYPE) {
    PDF_TYPE["JANAK_CASH_FLOW"] = "JANAK_CASH_FLOW";
    PDF_TYPE["SYNXIS"] = "SYNXIS";
})(PDF_TYPE = exports.PDF_TYPE || (exports.PDF_TYPE = {}));
// export enum USER_ROLE {
//   NONE = "NONE",
//   AUTHENTICATED = "AUTHENTICATED",
//   PUBLIC = "PUBLIC",
//   SYSTEM_ADMIN = "SYSTEM_ADMIN",
//   ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
//   MASTER_ADMIN = "MASTER_ADMIN",
//   MASTER_STAFF = "MASTER_STAFF",
//   SUB_CLIENT_USER = "SUB_CLIENT_USER",
//   SUB_CLIENT_OWNER = "SUB_CLIENT_OWNER",
//   MASTER_DOWNLOADER = "MASTER_DOWNLOADER",
//   ENTITY_ADMIN = "ENTITY_ADMIN",
// }
var BOT_MACHINE_LOG_STATUS;
(function (BOT_MACHINE_LOG_STATUS) {
    BOT_MACHINE_LOG_STATUS["PENDING"] = "PENDING";
    BOT_MACHINE_LOG_STATUS["RUNNING"] = "RUNNING";
    BOT_MACHINE_LOG_STATUS["STOPPED"] = "STOPPED";
    BOT_MACHINE_LOG_STATUS["COMPLETED"] = "COMPLETED";
    BOT_MACHINE_LOG_STATUS["INTERRUPTED"] = "INTERRUPTED";
})(BOT_MACHINE_LOG_STATUS = exports.BOT_MACHINE_LOG_STATUS || (exports.BOT_MACHINE_LOG_STATUS = {}));
var BOT_TYPE;
(function (BOT_TYPE) {
    BOT_TYPE["EXTRACT_SUB_CLIENT_DETAIL"] = "EXTRACT_SUB_CLIENT_DETAIL";
    BOT_TYPE["FILE_MONTHLY_TAX"] = "FILE_MONTHLY_TAX";
    BOT_TYPE["DOWNLOAD_SALES_TAX_CONFIRMATION"] = "DOWNLOAD_SALES_TAX_CONFIRMATION";
    BOT_TYPE["DOWNLOAD_TOURISM_TAX_CONFIRMATION"] = "DOWNLOAD_TOURISM_TAX_CONFIRMATION";
    BOT_TYPE["FILE_TOURISM_TAX"] = "FILE_TOURISM_TAX";
    BOT_TYPE["UPDATE_REVENUE_BY_READING_EMAIL"] = "UPDATE_REVENUE_BY_READING_EMAIL";
    BOT_TYPE["UPDATE_BANK_DETAIL_ON_COUNTY_WEBSITE"] = "UPDATE_BANK_DETAIL_ON_COUNTY_WEBSITE";
    BOT_TYPE["UPDATE_REVENUE_BY_PMS_POS"] = "UPDATE_REVENUE_BY_PMS_POS";
    BOT_TYPE["EXTRACT_PAST_TOURISM_TAX_CONFIRMATION_REPORTS"] = "EXTRACT_PAST_TOURISM_TAX_CONFIRMATION_REPORTS";
    BOT_TYPE["EXTRACT_PAST_SALES_TAX_CONFIRMATION_REPORTS"] = "EXTRACT_PAST_SALES_TAX_CONFIRMATION_REPORTS";
    BOT_TYPE["CONFIRM_BANK_INFORMATION_SYSTEM_VS_STATE"] = "CONFIRM_BANK_INFORMATION_SYSTEM_VS_STATE";
    BOT_TYPE["CONFIRM_BANK_INFORMATION_SYSTEM_VS_COUNTY"] = "CONFIRM_BANK_INFORMATION_SYSTEM_VS_COUNTY";
    BOT_TYPE["UPDATE_BANK_DETAIL_ON_STATE_WEBSITE"] = "UPDATE_BANK_DETAIL_ON_STATE_WEBSITE";
    BOT_TYPE["IMPORT_HISTORICAL_DATA_FOR_BUSINESS_ENTITY"] = "IMPORT_HISTORICAL_DATA_FOR_BUSINESS_ENTITY";
    BOT_TYPE["IMPORT_SALES_REPORT_FROM_PMS_POS"] = "IMPORT_SALES_REPORT_FROM_PMS_POS";
    BOT_TYPE["IMPORT_HOURLY_SALES_REPORT_FROM_PMS_POS"] = "IMPORT_HOURLY_SALES_REPORT_FROM_PMS_POS";
    BOT_TYPE["RECONCILE_CONTACT_INFO_WITH_STATE"] = "RECONCILE_CONTACT_INFO_WITH_STATE";
    BOT_TYPE["UPDATE_CONTACT_INFO_ON_STATE"] = "UPDATE_CONTACT_INFO_ON_STATE";
    BOT_TYPE["DOWNLOAD_BANK_CC_TRANSACTIONS"] = "DOWNLOAD_BANK_CC_TRANSACTIONS";
    BOT_TYPE["DOWNLOAD_BANK_CC_STATEMENT"] = "DOWNLOAD_BANK_CC_STATEMENT";
    BOT_TYPE["DOWNLOAD_FRANCHISE_INVOICE"] = "DOWNLOAD_FRANCHISE_INVOICE";
    BOT_TYPE["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    BOT_TYPE["CHANGE_TOURISM_TAX_PASSWORD"] = "CHANGE_TOURISM_TAX_PASSWORD";
    BOT_TYPE["DOWNLOAD_MONTHLY_REPORT_FROM_PMS_POS"] = "DOWNLOAD_MONTHLY_REPORT_FROM_PMS_POS";
    BOT_TYPE["APPFOLIO_TAX_PAYMENT_ENTRY"] = "APPFOLIO_TAX_PAYMENT_ENTRY";
})(BOT_TYPE = exports.BOT_TYPE || (exports.BOT_TYPE = {}));
var STATE_TAX_RECEIPT_TYPE;
(function (STATE_TAX_RECEIPT_TYPE) {
    STATE_TAX_RECEIPT_TYPE["STATE_OF_FLORIDA"] = "STATE_OF_FLORIDA";
    STATE_TAX_RECEIPT_TYPE["SAXTAX"] = "SAXTAX";
})(STATE_TAX_RECEIPT_TYPE = exports.STATE_TAX_RECEIPT_TYPE || (exports.STATE_TAX_RECEIPT_TYPE = {}));
var CUSTOM_ENUM;
(function (CUSTOM_ENUM) {
    CUSTOM_ENUM["BANK_TYPE"] = "BANK_TYPE";
    CUSTOM_ENUM["BANK_TRANSACTION_TYPE"] = "BANK_TRANSACTION_TYPE";
    CUSTOM_ENUM["WEEK_DAYS"] = "WEEK_DAYS";
    CUSTOM_ENUM["MONTH_DAYS"] = "MONTH_DAYS";
    CUSTOM_ENUM["FRANCHISE"] = "FRANCHISE";
    CUSTOM_ENUM["BANK_ACCOUNT_TYPE"] = "BANK_ACCOUNT_TYPE";
    CUSTOM_ENUM["BOT_PROCESS_ENTITY_TYPE_CODE"] = "BOT_PROCESS_ENTITY_TYPE_CODE";
    CUSTOM_ENUM["SUB_CLIENT_BUSINESS_TYPE"] = "SUB_CLIENT_BUSINESS_TYPE";
    CUSTOM_ENUM["TAX_PROCESS_FINAL_STEP"] = "TAX_PROCESS_FINAL_STEP";
    CUSTOM_ENUM["SUB_CLIENT_REVENUE_SUBMISSION_TYPE"] = "SUB_CLIENT_REVENUE_SUBMISSION_TYPE";
    CUSTOM_ENUM["SUB_CLIENT_TAX_FORM"] = "SUB_CLIENT_TAX_FORM";
    CUSTOM_ENUM["SUB_CLIENT_REPORTING_PATTERN"] = "SUB_CLIENT_REPORTING_PATTERN";
    CUSTOM_ENUM["BOT_PROCESS_MACHINE_CAPABILITY"] = "BOT_PROCESS_MACHINE_CAPABILITY";
    CUSTOM_ENUM["MESSAGE_TYPE"] = "MESSAGE_TYPE";
    CUSTOM_ENUM["BOT_PROCESS_QUEUE_STATUS"] = "BOT_PROCESS_QUEUE_STATUS";
    CUSTOM_ENUM["FREQUENCY_OF_FILING"] = "FREQUENCY_OF_FILING";
    CUSTOM_ENUM["GLOBAL_SETTING_FIELD_TYPE"] = "GLOBAL_SETTING_FIELD_TYPE";
    CUSTOM_ENUM["BOT_PROCESS_OPERATING_SYSTEM"] = "BOT_PROCESS_OPERATING_SYSTEM";
    CUSTOM_ENUM["BOT_PROCESS_INTERVAL"] = "BOT_PROCESS_INTERVAL";
    CUSTOM_ENUM["BOT_TYPE_CATEGORY"] = "BOT_TYPE_CATEGORY";
    CUSTOM_ENUM["REVENUE_TYPE"] = "REVENUE_TYPE";
    CUSTOM_ENUM["USER_ROLE"] = "USER_ROLE";
    CUSTOM_ENUM["ADMIN_ROLES"] = "ADMIN_ROLES";
    CUSTOM_ENUM["BOT_STATUS"] = "BOT_STATUS";
    CUSTOM_ENUM["FIELD_TYPE"] = "FIELD_TYPE";
    CUSTOM_ENUM["INCOME_TYPE"] = "INCOME_TYPE";
    CUSTOM_ENUM["SUBMISSION_FORM_CALCULATED_FIELDS"] = "SUBMISSION_FORM_CALCULATED_FIELDS";
    CUSTOM_ENUM["COUNTY_VENDORS"] = "COUNTY_VENDORS";
    CUSTOM_ENUM["ACTION_LOG_TYPE"] = "ACTION_LOG_TYPE";
    CUSTOM_ENUM["MASTER_CLIENT_FEATURE"] = "MASTER_CLIENT_FEATURE";
    CUSTOM_ENUM["REPORT_TYPES"] = "REPORT_TYPES";
    CUSTOM_ENUM["REPORT_INTERVAL"] = "REPORT_INTERVAL";
    CUSTOM_ENUM["REPORT_COMPARISON_TYPE"] = "REPORT_COMPARISON_TYPE";
    CUSTOM_ENUM["BUSINESS_ENTITY_EMAIL_TYPE"] = "BUSINESS_ENTITY_EMAIL_TYPE";
    CUSTOM_ENUM["TFA_TIME_LIMIT"] = "TFA_TIME_LIMIT";
    CUSTOM_ENUM["PERCENTAGE_VALUE_TYPE"] = "PERCENTAGE_VALUE_TYPE";
})(CUSTOM_ENUM = exports.CUSTOM_ENUM || (exports.CUSTOM_ENUM = {}));
var PMS_POS;
(function (PMS_POS) {
    PMS_POS["APPFOLIO"] = "APPFOLIO";
    PMS_POS["DUNKIN_DONUTS"] = "DUNKIN_DONUTS";
    PMS_POS["TERIYAKI_MADNESS"] = "TERIYAKI_MADNESS";
})(PMS_POS = exports.PMS_POS || (exports.PMS_POS = {}));
var SUB_CLIENT_REMINDER_TYPE;
(function (SUB_CLIENT_REMINDER_TYPE) {
    SUB_CLIENT_REMINDER_TYPE["REVENUE_REMINDER"] = "REVENUE_REMINDER";
    SUB_CLIENT_REMINDER_TYPE["REVENUE_REMINDER_ON_LAST_DAY"] = "REVENUE_REMINDER_ON_LAST_DAY";
    SUB_CLIENT_REMINDER_TYPE["PAYMENT_DEDUCTION_REMINDER"] = "PAYMENT_DEDUCTION_REMINDER";
    SUB_CLIENT_REMINDER_TYPE["TAX_FILING_CONFIRMATION"] = "TAX_FILING_CONFIRMATION";
})(SUB_CLIENT_REMINDER_TYPE = exports.SUB_CLIENT_REMINDER_TYPE || (exports.SUB_CLIENT_REMINDER_TYPE = {}));
var DOCUMENT_TYPE;
(function (DOCUMENT_TYPE) {
    DOCUMENT_TYPE["TAX_PAYMENT_RECEIPT"] = "TAX_PAYMENT_RECEIPT";
    DOCUMENT_TYPE["COUNTY_TOURISM_TAX_CONFIRMATION"] = "COUNTY_TOURISM_TAX_CONFIRMATION";
    DOCUMENT_TYPE["SUB_CLIENT_UPLOADS"] = "SUB_CLIENT_UPLOADS";
    DOCUMENT_TYPE["SUBMISSION_FROM_SNAPSHOT"] = "SUBMISSION_FROM_SNAPSHOT";
    DOCUMENT_TYPE["TOTAL_TAX_COLLECTED"] = "TOTAL_TAX_COLLECTED";
    DOCUMENT_TYPE["MISCELLANEOUS_REPORT"] = "MISCELLANEOUS_REPORT";
    DOCUMENT_TYPE["TAX_EXEMPT_REPORT"] = "TAX_EXEMPT_REPORT";
    DOCUMENT_TYPE["MONTHLY_REVENUE_REPORT"] = "MONTHLY_REVENUE_REPORT";
    DOCUMENT_TYPE["MULTIPLE_MERGED_REPORTS"] = "MULTIPLE_MERGED_REPORTS";
    DOCUMENT_TYPE["FRANCHISE_INVOICE"] = "FRANCHISE_INVOICE";
    DOCUMENT_TYPE["FRANCHISE_INVOICE_BACKUP"] = "FRANCHISE_INVOICE_BACKUP";
    DOCUMENT_TYPE["BANK_CC_STATEMENT"] = "BANK_CC_STATEMENT";
    DOCUMENT_TYPE["BANK_CC_TRANSACTION"] = "BANK_CC_TRANSACTION";
})(DOCUMENT_TYPE = exports.DOCUMENT_TYPE || (exports.DOCUMENT_TYPE = {}));
//# sourceMappingURL=enums.js.map